import { render } from "./EditFoodOrders-group-step-3.vue?vue&type=template&id=5e74d236"
import script from "./EditFoodOrders-group-step-3.vue?vue&type=script&lang=js"
export * from "./EditFoodOrders-group-step-3.vue?vue&type=script&lang=js"

import "./EditFoodOrders-group-step-3.vue?vue&type=style&index=0&id=5e74d236&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__